export default __webpack_public_path__ + "static/media/ic_symbolHyundai.e0b99fd2.svg";